export const DISABLED_URLS_STORES = {
  ja_jp: ['/service/return-your-watch-to-manufacture']
}
